const fonts = ["Arial", "Futura", "Georgia", "Helvetica", "Verdana"]

const fontWeight = ["bold", "normal"]

export default { fonts, fontWeight }